type TranslationDict = Record<string, string>;

const ja: TranslationDict = {
  // config-panel shared
  'configPanel.selectFile': 'ファイルを選択',
  'configPanel.selectFromDrive': 'Driveから選択',
  'configPanel.selectKeyVisual': 'キービジュアルを選択',

  // camera motions
  'cam.none': '指定なし',
  'cam.panLeft': '左パン',
  'cam.panRight': '右パン',
  'cam.zoomIn': 'ズームイン',
  'cam.zoomOut': 'ズームアウト',
  'cam.tiltUp': '上チルト',
  'cam.tiltDown': '下チルト',
  'cam.locked': '固定',
  'cam.handheld': '手持ち',

  // prompt styles
  'style.none': 'なし',
  'style.anime': 'アニメ',
  'style.3d': '3D',
  'style.fantasy': 'ファンタジー',
  'style.cinematic': 'シネマティック',
  'style.claymation': 'クレイアニメ',
  'style.lineArt': '線画',
  'style.stopMotion': 'ストップモーション',
  'style.2d': '2D',
  'style.vectorArt': 'ベクターアート',
  'style.monochrome': 'モノクロ',

  // shot angles
  'angle.none': 'なし',
  'angle.aerial': '空撮',
  'angle.eyeLevel': 'アイレベル',
  'angle.high': 'ハイアングル',
  'angle.low': 'ローアングル',
  'angle.topDown': '真上から',

  // video-settings-without-size labels
  'videoSettings.cameraMotion': 'カメラモーション',
  'videoSettings.shotAngle': 'ショットアングル',
  'videoSettings.promptStyle': 'プロンプトスタイル',
  'videoSettings.shotSize': 'ショットサイズ',

  // shot sizes
  'shotSize.none': 'なし',
  'shotSize.closeUp': 'クローズアップ',
  'shotSize.extremeCloseUp': 'エクストリームクローズアップ',
  'shotSize.medium': 'ミディアムショット',
  'shotSize.long': 'ロングショット',
  'shotSize.extremeLong': 'エクストリームロングショット',

  // common
  'common.generatingImage': '画像を生成中...',
  'common.weak': '弱',
  'common.strong': '強',
  'common.resetToDefaults': 'デフォルトに戻す',

  // storyboard-generator
  'storyboard.title': 'ラフデザイン作成',
  'storyboard.subtitle': '手書き絵からラフデザインを生成',
  'storyboard.addScene': 'シーンを追加',
  'storyboard.detailSettings': '詳細設定',
  'storyboard.styleRefImage': 'スタイル参照画像',
  'storyboard.selectImage': '画像を選択',
  'storyboard.stylePreset': 'スタイルプリセット',
  'storyboard.searchStyle': 'スタイルを検索...',
  'storyboard.styleStrength': 'スタイル適用強度',
  'storyboard.visualIntensity': '視覚的な適用強度',
  'storyboard.structureStrength': '構造強度',
  'storyboard.sceneTextPlaceholder': 'ここにテキストを入力してください',

  // storyboard3d
  'storyboard3d.title': '3Dから絵コンテ',
  'storyboard3d.subtitle': '3Dモデルを使った絵コンテ作成',
  'storyboard3d.viewFront': '前面ビュー',
  'storyboard3d.viewTop': '上面ビュー',
  'storyboard3d.viewSide': '側面ビュー',
  'storyboard3d.stockLink': 'Adobe Stockから3Dモデルをダウンロード',
  'storyboard3d.promptPlaceholder': '画像生成のプロンプトを入力...',
  'storyboard3d.generateImage': '画像を生成',
  'storyboard3d.noImageHint': '3Dモデルで構図を決めて、画像を生成してください。',

  // key-visual-splitter
  'kvs.subtitle': '一枚の画像から多様なバリエーションを生成',
  'kvs.configTitle': '設定',
  'kvs.uploadLabel': 'キービジュアルをアップロード',
  'kvs.uploadPlaceholder': '画像をドロップまたはクリック',
  'kvs.uploadHint': 'JPG, PNG, GIF, WebP (最大10MB)',
  'kvs.promptLabel': '動画の演出を記述',
  'kvs.promptPlaceholder': 'カメラがゆっくりズームインしながら、光が差し込む演出。背景には粒子が舞い、幻想的な雰囲気を演出。',
  'kvs.generateBtn': '動画を生成',
  'kvs.generatingBtn': '生成中...',
  'kvs.videoSettingsTitle': '3. 動画設定',
  'kvs.optional': '(任意)',
  'kvs.videoSize': '動画サイズ',
  'kvs.cameraMotion': 'カメラモーション',
  'kvs.splitTitle': '4. 分割数を設定',
  'kvs.splitUnit': '枚',
  'kvs.emptyTitle': 'キービジュアルをアップロードして開始',
  'kvs.emptyText': '左側のパネルから画像を選択し、動画の演出を記述してください',
  'kvs.progressTitle': '動画を生成中...',
  'kvs.resultTitle': '生成完了！',
  'kvs.resultSubtitle': '動画生成と{count}枚のフレーム分割が完了しました',
  'kvs.videoSectionTitle': '生成された動画',
  'kvs.videoNotSupported': 'お使いのブラウザは動画再生をサポートしていません。',
  'kvs.framesTitle': '分割フレーム ({count}枚)',
  'kvs.splitting': '分割中...',
  'kvs.resplit': '再分割',
  'kvs.frameAlt': 'フレーム',
  'kvs.stepGenerate': '動画生成',
  'kvs.stepSplit': '動画分割',

  // visual-narrative-maker
  'vnm.subtitle': 'CSV データから一貫性のあるビジュアルストーリーを自動生成',
  'vnm.generatingImages': '画像生成中...',
  'vnm.generatingVideos': '動画生成中...',
  'vnm.combiningVideos': '動画結合中...',
  'vnm.generateSceneImages': 'シーン画像を生成',
  'vnm.generatingBtn': '生成中...',
  'vnm.generateVideo': '動画を生成',
  'vnm.generatingVideoBtn': '動画生成中...',
  'vnm.combineVideo': '動画を結合',
  'vnm.combiningBtn': '結合中...',
  'vnm.saving': '保存中...',
  'vnm.saveSelected': '選択画像を保存',
  'vnm.tabScenes': 'シーンプレビュー',
  'vnm.tabCombined': '結合動画',
  'vnm.sceneN': 'シーン {n}',
  'vnm.detailSettings': '詳細設定',
  'vnm.regenerateImage': '画像を再生成',
  'vnm.regenerateVideo': '動画を再生成',
  'vnm.deleteScene': 'シーンを削除',
  'vnm.delete': '削除',
  'vnm.prompt': 'プロンプト',
  'vnm.promptPlaceholder': 'プロンプトを入力',
  'vnm.negativePrompt': 'ネガティブプロンプト',
  'vnm.negativePromptPlaceholder': 'ネガティブプロンプトを入力（オプション）',
  'vnm.cameraMotion': 'カメラモーション',
  'vnm.generatedImage': '生成画像',
  'vnm.sceneImageAlt': 'シーン {n} 画像',
  'vnm.placeholder': 'プレースホルダー',
  'vnm.variationAlt': 'バリエーション {n}',
  'vnm.generatedVideo': '生成動画',
  'vnm.addScene': '+ シーンを追加',
  'vnm.emptyHint': 'シーン情報を入力して動画を生成してください',
  'vnm.emptySubHint': '各シーンには詳細なプロンプトを入力することで、より高品質な結果が得られます',
  'vnm.editVideo': '動画を編集',
  // csv uploader
  'vnm.csvUpload': 'CSVアップロード',
  'vnm.selectCsv': 'CSVを選択',
  // style config
  'vnm.styleRefMode': 'スタイル参照方式',
  'vnm.refImage': '参照画像',
  'vnm.customModel': 'カスタムモデル（スタイル）',
  'vnm.dropStyleImage': 'スタイル参照画像をドロップ',
  'vnm.styleImageHint': '生成するシーンに適用するスタイルの基準となる画像',
  'vnm.selectFile': 'ファイルを選択',
  'vnm.selectFromDrive': 'Driveから選択',
  'vnm.uploadingImage': '画像を読み込み中...',
  'vnm.styleRefImageAlt': 'スタイル参照画像',
  'vnm.styleStrengthLabel': 'スタイル適用強度: ',
  'vnm.loadingCustomModels': 'カスタムモデルを読み込み中...',
  'vnm.selectCustomModel': 'カスタムモデルを選択',
  'vnm.noCustomModels': '利用可能なカスタムモデルがありません',
  'vnm.selectedModelInfo': '選択モデル情報:',
  'vnm.keyword': 'キーワード: ',
  'vnm.modelVersion': 'モデルバージョン: ',
  'vnm.samplePrompt': 'サンプルプロンプト: ',
  'vnm.visualIntensityLabel': '視覚的な適用量: ',
  'vnm.videoSettings': '動画設定',
  'vnm.videoSizeAll': '動画サイズ（全シーン共通）',
  'vnm.defaultCameraMotion': 'デフォルトカメラモーション',
  'vnm.selectStyleRef': 'スタイル参照画像を選択',
  // scene preview
  'vnm.promptLabel': 'プロンプト:',
  'vnm.negativePromptLabel': 'ネガティブプロンプト:',
  'vnm.sceneIndividualSettings': 'シーン個別動画設定',
  'vnm.videoSettingsTitle': '動画設定',

  // custom-model-generator
  'cmig.title': 'カスタムモデルジェネレーター',
  'cmig.subtitle': 'Fireflyカスタムモデルを使用した画像生成',
  'cmig.customModel': 'カスタムモデル',
  'cmig.loadingModels': 'カスタムモデルを読み込み中...',
  'cmig.selectModel': 'モデルを選択',
  'cmig.selectModelPlaceholder': 'カスタムモデルを選択',
  'cmig.noModels': 'カスタムモデルがありません',
  'cmig.numImages': '生成枚数',
  'cmig.numImagesOption1': '1枚',
  'cmig.numImagesOption2': '2枚',
  'cmig.numImagesOption4': '4枚',
  'cmig.ratio': '割合',
  'cmig.structureImage': '構成画像',
  'cmig.dragDrop': 'ドラッグ＆ドロップ',
  'cmig.formatsHint': 'JPG / PNG (最小512x512 px、最大15MB)',
  'cmig.structureImagePreviewAlt': '構成画像プレビュー',
  'cmig.removeStructureImage': '構成画像を削除',
  'cmig.stuctureImageCm5warning': '構成画像を使用する場合、割合フィールドは利用できません',
  'cmig.uploading': 'アップロード中...',
  'cmig.generatingImage': '画像を生成中...',
  'cmig.generationResults': '生成結果 : ',
  'cmig.downloadImage': '画像をダウンロード',
  'cmig.generatedImageAlt': '生成画像 {index}',
  'cmig.placeholderTitle': 'プロンプトから画像が1枚生成されます。',
  'cmig.placeholderTip1': 'アスペクト比を必ず指定してください。',
  'cmig.placeholderTip2': '求める内容をより詳細に記述してください。',
  'cmig.promptLabel': 'プロンプト',
  'cmig.promptPlaceholder': '生成したい画像を説明してください...',
  'cmig.termsTitle': 'PVS利用規約',
  'cmig.permittedUseLabel': '利用目的',
  'cmig.permittedUseBody1': 'PVSシステムはPanasonic製品およびサービスの販促目的でのみ使用できます。それ以外の目的での使用は固く禁止されています。',
  'cmig.permittedUseBody2': '本利用規約は、PVSを使用して生成されたコンテンツ、およびPVSを使用して変更された既存のコンテンツの両方に適用されます。',
  'cmig.permittedUseBody3': '本利用規約の遵守に加え、すべての利用者は、Panasonicの「生成AI画像・動画・音声コンテンツに関するグローバルガイドライン」（随時改定・更新されるものを含む）に定められた、適用されるすべての規則、要件および制限を遵守する必要があります。',
  'cmig.externalSuppliersTitle': '外部サプライヤーおよび個人クリエイター',
  'cmig.externalSuppliersBody': '外部サプライヤー、個人クリエイターおよびその他の第三者は、Panasonicから正式にクリエイティブコンテンツの制作を委託された場合に限り、本システムを使用することができます。委託されたプロジェクト以外の目的での使用は固く禁止されています。',
  'cmig.panasonicEmployeesTitle': 'Panasonicグループの全世界の従業員',
  'cmig.panasonicEmployeesBody': 'Panasonicグループの全世界の従業員は、Panasonic製品およびサービスの販促資料を作成する目的以外で、他社または第三者に本システムを使用させてはなりません。',
  'cmig.doWord': '推奨',
  'cmig.doNotWord': '禁止',
  'cmig.aiModelSelectionTitle': 'AIモデルの選択',
  'cmig.aiModelSelectionDo1': 'Panasonicカスタムモデルを使用したAdobe Fireflyを使用してください。',
  'cmig.aiModelSelectionDoNot1': 'Adobe Fireflyのパートナーモデルは使用しないでください。同等の商用利用権、知的財産補償、学習データの透明性がありません。',
  'cmig.beforeGenTitle': '画像生成前',
  'cmig.beforeGenDoNot1': '製品の利点を誤解を招く形で、誇張して、または虚偽に示唆・表現するコンテンツ、あるいは製品・サービス、その機能、性能、結果その他の重要な主張を誤って伝えるコンテンツを、生成AIで作成・改変しないでください。',
  'cmig.beforeGenDoNot2': '機密情報、個人情報、第三者からPanasonicに提供された機密情報、または未公開の製品情報を入力しないでください。',
  'cmig.beforeGenDoNot3': '名誉毀損に当たる可能性がある情報、または他者のプライバシーを侵害する可能性がある情報を入力しないでください。',
  'cmig.beforeGenDoNot4': '人物、架空のキャラクター、作品名、ランドマーク、建物、ブランドなど、名前が特定される、または一意に識別可能な被写体を含むプロンプトや参照画像を使用しないでください。',
  'cmig.beforeGenDoNot5': '他者が制作した視覚素材を含む、著作権侵害につながる可能性のあるコンテンツを含むプロンプトや参照画像を使用しないでください。',
  'cmig.beforeGenDoNot6': '特定のアーティスト、著名な芸術的スタイル、既存の作品を模倣するようAIに指示しないでください。',
  'cmig.beforeGenDoNot7': 'AIを使用して画像内の人物の人種や性別を変更しないでください。',
  'cmig.beforeGenDoNot8': 'Global Marketing Division Brand Strategy Departmentの事前承認（承認依頼先：pvs@ml.jp.panasonic.com）を得ていない限り、Panasonic Visual StudioのVisual Narrative MakerまたはKey Frame Generatorを使用しないでください。',
  'cmig.beforeGenDo1': '計画しているコンテンツが、批判や反発を含む評判・社会的リスクを生む可能性がないか検討してください。',
  'cmig.beforeGenDo2': 'すべてのAI画像生成が適用される現地の法令・規制を遵守していることを確認してください。',
  'cmig.beforeGenDo3': '問題が生じた場合に対応できるよう、画像生成に使用したプロンプトの記録を保持してください。',
  'cmig.beforeGenDo4': 'イラストを生成する際は特に注意してください。イラストの画風は写実的な画像よりも認識されやすく、既存の著作物との類似リスクが高くなります。',
  'cmig.beforeGenDo5': 'Sketch to Storyboard、3D Sketch、Visual Narrative Makerは社内レビュー資料としてのみ使用してください。',
  'cmig.afterGenTitle': '画像生成後',
  'cmig.afterGenDoNot1': '既存の作品、製品、物体、キャラクター、ロゴ、デザインと酷似しているコンテンツを含め、第三者の著作権、商標権その他の知的財産権を侵害する、または侵害するおそれのあるコンテンツを使用しないでください。',
  'cmig.afterGenDoNot2': '関連する権利や許諾なしに、特定可能な人物の肖像や外見を模倣している、または模倣していると合理的に誤解されうるコンテンツを使用しないでください。',
  'cmig.afterGenDoNot3': '色や意匠の特徴的な組み合わせを含め、スポーツチーム、クラブ、リーグ、大会の名称、紋章、バッジ、ロゴ、マスコット、キット、ユニフォームその他の識別要素を、関連する権利や許諾なしに使用・模倣・酷似させないでください。',
  'cmig.afterGenDoNot4': '類似性チェックの結果、既存の作品と酷似していると判明したAI生成コンテンツは使用しないでください。類似性が解消されるまで、新しいバージョンを作成するか編集してください。',
  'cmig.afterGenDoNot5': 'AI生成の製品画像をPanasonic製品の公式画像として使用しないでください。AIによって製品の形状、ディテール、仕上げが変わることがあります。',
  'cmig.afterGenDo1': '使用前にAI生成コンテンツを編集・後処理してください。不自然な要素、視覚的な不整合、レイアウトその他の品質上の問題を修正してください。',
  'cmig.afterGenDo2': 'AI生成コンテンツが既存の作品、製品、物体と酷似していないか確認してください。確認には、機密情報を含まない場合に限り、逆画像検索または本目的で承認されたAIサービスを使用してください。',
  'cmig.afterGenDo3': 'コンテンツが正確かつ一貫しており、Panasonicのブランドガイドラインに準拠し、差別的表現を含まず、契約または書面による許諾で生成AIによる編集が明示的に認められていない限り第三者のコンテンツを使用しておらず、意図する用途に適していることを確認してください。',
  'cmig.afterGenDo4': '対象コンテンツに著作権保護が必要かどうかを検討してください。必要な場合は十分な人間による創作的関与を確保してください。プロンプトのみでは不十分な場合があります。疑義がある場合は法務にご相談ください。',
  'cmig.afterGenDo5': 'AI生成画像が適用される現地の法令・規制を遵守していることを確認してください。',
  'cmig.afterGenDo6': '現地の法令・規制で求められる場合は、AI生成コンテンツにラベル表示または透かしを付与してください。',
  'cmig.afterGenDo7': 'AI改変コンテンツに関する要件を含め、Panasonicの地域ごとのラベル表示・開示要件を遵守してください。',
  'cmig.afterGenDo8': '契約対象者の肖像や外見から、リアルな新規または大幅に改変されたパフォーマンスをAIで作成する前に、法務の助言を得てください。',
  'cmig.afterGenDo9': 'AI生成コンテンツにPanasonic製品が登場する場合は、後処理工程で実際のPanasonic製品の承認済み写真を最終クリエイティブに合成してください。',
  'cmig.afterGenDo10': 'AI生成画像とプロンプトは、セッションごとに自動的に削除されるため、次の画像を生成する前に保存してください。',
  'cmig.afterGenDo11': '外部で使用する前に、少なくとも3名のCommunication Category HeadによるAI生成コンテンツのレビューと承認を受けてください。',
  'cmig.bestPracticeTitle': 'ベストプラクティス',
  'cmig.bestPracticeDo1': '出力品質を維持するため、可能な限り希望する出力画像と同じアスペクト比の参照画像を使用してください。',
  'cmig.bestPracticeDo2': 'AI生成テキストの正確性は保証されないため、テキスト要素を含む画像の生成は避けてください。',
  'cmig.bestPracticeDo3': '複数人が写る画像は、指の欠損などの解剖学的な不整合を含む不自然なアーティファクトが特に発生しやすいため、注意を払ってください。',
  'cmig.bestPracticeDo4': '植物やその他の自然物を生成する際は、AIが不正確な、または実在しない種を生成することがあるため、特に注意してください。',
  'cmig.confirmBefore': '生成前の確認事項',
  'cmig.confidentialInfoLabel': '機密情報：',
  'cmig.confidentialInfoBody': '未公開の情報を参照画像に使用しないでください。',
  'cmig.copyrightLabel': '著作権：',
  'cmig.copyrightBody': '著作権で保護されたコンテンツ（プロンプト・参照画像とも）を使用しないでください。',
  'cmig.matchAspectRatioLabel': 'アスペクト比の一致：',
  'cmig.matchAspectRatioBody': '参照画像のアスペクト比を生成したい画像に合わせると、より良い結果が得られます。',
  'cmig.confirmAfter': '生成後の確認事項',
  'cmig.saveImmediatelyLabel': 'すぐに保存：',
  'cmig.saveImmediatelyBody': '生成された画像は自動削除されます。新しい画像を生成する前に必ず保存してください。',
  'cmig.checkSimilarityLabel': '類似性の確認：',
  'cmig.checkSimilarityBody': '既存の製品・オブジェクトとの類似性を確認してください。',
  'cmig.ethicalCheckLabel': '倫理チェック：',
  'cmig.ethicalCheckBody': '生成画像にステレオタイプや不適切な内容がないか確認してください。',
  'cmig.legalComplianceLabel': '法令遵守：',
  'cmig.legalComplianceBody': '各地域の法令に従ってください。必要な場合は透かしを追加してください。',
  'cmig.qualityCheckLabel': '品質チェック：',
  'cmig.qualityCheckBody': '3人以上でおかしな箇所（指の本数の誤りなど）がないか確認し、必要に応じて修正してください。',
  'cmig.brandSafetyLabel': 'ブランドセーフティ：',
  'cmig.brandSafetyBody': '3人以上写っている画像は誤りのリスクが高いため注意してください（不自然な体の構造や表現の乱れなど）。',
  'cmig.productImagesLabel': '製品画像：',
  'cmig.productImagesBody': 'AI生成画像はあくまでイメージ用です。実際の製品画像を必ず合成・修正してから使用してください（Panasonic製品のみ）。',
  'cmig.generate': '生成',
  'cmig.generating': '生成中...',
  'cmig.promptGuideTitle': 'プロンプトガイド',
  'cmig.promptGuideText': '高品質な画像を生成するには、主題を明確に、照明・構図・スタイルなどの具体的な詳細を記述してください。色使いや質感、雰囲気などの視覚要素を含めましょう。必要に応じて「広角ショット」「クローズアップ」のようにアングルや視点を指定してください。曖昧な表現は避け、具体的な形容詞を使ってモデルを効果的に導いてください。',
  'cmig.toast.fileTooLarge': 'ファイルサイズが大きすぎます（上限15MB）',
  'cmig.toast.structureUploadSuccess': '構成画像がアップロードされました',
  'cmig.toast.structureUploadFailed': '構成画像のアップロードに失敗しました',
  'cmig.toast.jobStartFailed': 'ジョブの開始に失敗しました',
  'cmig.toast.imageGenerated': '画像が生成されました',
  'cmig.toast.emptyResult': '画像生成が完了しましたが、結果が空でした',
  'cmig.toast.noResultFound': '画像生成が完了しましたが、結果が見つかりませんでした',
  'cmig.toast.generationFailed': '画像生成に失敗しました: {detail}',
  'cmig.toast.statusFetchFailed': '画像生成のステータス取得に失敗しました',
  'cmig.toast.requestFailed': '画像生成の開始に失敗しました',
  'cmig.toast.downloadFailed': '画像のダウンロードに失敗しました',

  // toast messages — storyboard / storyboard3d
  'toast.structureUploadError': '構造画像のアップロードに失敗しました',
  'toast.jobStartFailed': '画像生成ジョブの開始に失敗しました',
  'toast.imageResultEmpty': '画像生成結果が空です',
  'toast.imageGenFailed': '画像生成に失敗しました: {detail}',
  'toast.jobMonitorError': 'ジョブ監視中にエラーが発生しました: {detail}',
  'toast.unknownError': '不明なエラー',
  'toast.unknownErrorOccurred': '不明なエラーが発生しました',
  'toast.imageUploadFailed': '画像アップロードに失敗しました',
  'toast.imageGenRequestFailed': '画像生成リクエストに失敗しました',
  'toast.imageGenRequestFailedDetail': '画像生成リクエストに失敗しました: {detail}',
  'toast.imageGenComplete': '画像生成が完了しました',
  'toast.imageLoadFailed': '画像の読み込みに失敗しました: {url}',
  'toast.unsupportedModel': '対応しているファイル形式は .obj, .glb, .gltf, .fbx です。',
  'toast.objLoaded': 'OBJモデルの読み込みが完了しました。',
  'toast.objLoadFailed': 'OBJファイルの読み込みに失敗しました。',
  'toast.gltfLoaded': 'GLTF/GLBモデルの読み込みが完了しました。',
  'toast.gltfLoadFailed': 'GLTF/GLBファイルの読み込みに失敗しました。',
  'toast.fbxLoaded': 'FBXモデルの読み込みが完了しました。',
  'toast.fbxLoadFailed': 'FBXファイルの読み込みに失敗しました。ファイルが破損している可能性があります。',
  // toast messages — storyboard-settings
  'toast.fileTooLarge': 'ファイルサイズが大きすぎます（上限10MB）',
  'toast.unsupportedFormat': '非対応のファイル形式です',
  'toast.styleImageUploaded': 'スタイル参照画像がアップロードされました',
  'toast.styleImageUploadFailed': 'スタイル参照画像のアップロードに失敗しました',
  'toast.settingsReset': '設定をデフォルト値に戻しました',
  // toast messages — config-panel
  'toast.imageSelected': '画像を選択しました: {prompt}...',
  'toast.fileSizeExceeded': 'ファイルサイズが{maxSize}MBを超えています',
  // toast messages — narrative-style-config
  'toast.styleRefSelected': 'スタイル参照画像を選択しました: {prompt}...',
  // toast messages — narrative-error-handler
  'toast.sceneImageGenError': 'シーン{n}の画像生成エラー: {detail}',
  'toast.imageGenError': '画像生成エラー: {detail}',
  'toast.sceneVideoGenError': 'シーン{n}の動画生成エラー: {detail}',
  'toast.videoGenError': '動画生成エラー: {detail}',
  'toast.fileUploadError': 'ファイルアップロードエラー: {detail}',
  'toast.videoCombineError': '動画結合エラー: {detail}',
  'toast.validationErrorPrefix': '検証エラー: {detail}',
  // kvs — visual-split.service toasts
  'kvs.resplitFailed': '再分割に失敗しました',
  'kvs.apiChecking': 'Firefly動画生成API レスポンス確認中...',
  'kvs.videoJobStarted': '動画生成ジョブを開始しました',
  'kvs.videoJobStartFailed': '動画生成ジョブの開始に失敗しました',
  'kvs.generatingVideo': '動画生成中... ({status})',
  'kvs.videoGenComplete': '動画生成が完了しました',
  'kvs.videoUrlFailed': '動画URLの取得に失敗しました',
  'kvs.videoGenFailed': '動画生成が失敗しました',
  'kvs.videoGenError': '動画生成エラー',
  'kvs.videoSplitError': '動画分割エラー',
  'kvs.imageUploadFailed': '画像のアップロードに失敗しました',
  'kvs.networkError': 'ネットワークエラーが発生しました',
  'kvs.requestError': 'リクエストエラーが発生しました',
  'kvs.serverError': 'サーバーエラーが発生しました',
  'kvs.generalError': 'エラーが発生しました',
  'kvs.resplitSuccess': '動画を{count}枚のフレームに再分割しました',

  // vnm — workflow/generation service toasts
  'vnm.err.noScenes': 'シーンがありません',
  'vnm.err.allScenesNotGenerated': 'すべてのシーン画像が生成されていません',
  'vnm.err.noGeneratedImages': '生成された画像が見つかりません',
  'vnm.err.minVideosForCombine': '結合するには少なくとも2つの動画が必要です',
  'vnm.err.noCombinedVideo': '編集する動画がありません',
  'vnm.err.noSceneImageSelected': 'シーンの画像が選択されていません',
  'vnm.err.scenePromptRequired': 'シーン {scenes} にプロンプトを入力してください',
  'vnm.err.videoCombinateFailed': '動画の結合に失敗しました',
  'vnm.err.imageJobStartFailed': '画像生成ジョブの開始に失敗しました',
  'vnm.err.imageUploadFailed': '画像のアップロードに失敗しました',
  'vnm.err.csvEmpty': 'CSVファイルが空です',
  'vnm.err.csvNoPromptHeader': 'CSVには「prompt」ヘッダーが必要です',
  'vnm.err.csvInvalidFormat': 'CSVファイルのフォーマットが不正です',
  'vnm.err.csvReadError': 'ファイルの読み込み中にエラーが発生しました',
  'vnm.err.fileTypeInvalid': '非対応のファイル形式です',
  'vnm.err.fileSizeTooLarge': 'ファイルサイズが大きすぎます（上限10MB）',
  'vnm.err.fileReadFailed': 'ファイルの読み込みに失敗しました',
  'vnm.success.scenesLoaded': '{count}シーンを読み込みました',
  'vnm.success.sceneImageGenComplete': 'シーンの画像生成が完了しました',
  'vnm.success.sceneVideoGenComplete': 'シーンの動画生成が完了しました',
  'vnm.success.allImagesGenerated': '全ての画像生成に成功しました',
  'vnm.success.videoGenComplete': '動画生成が完了しました',
  'vnm.success.videoCombineComplete': '動画の結合が完了しました',
  'vnm.success.videoEditComplete': '動画の編集が完了しました',
  'vnm.info.generatingVideoFromScenes': '{count}つのシーンから動画を生成します',
  'vnm.info.scenesGenerated': '{count}つのシーン動画が生成されました',
  'vnm.info.combiningVideos': 'シーン動画を結合しています...',

  // google-drive-image-selector
  'drivePicker.close': '閉じる',
  'drivePicker.searchPlaceholder': 'プロンプトで検索...',
  'drivePicker.loading': '画像を読み込み中...',
  'drivePicker.noImages': '画像が見つかりません',
  'drivePicker.noSearchResults': '検索条件に一致する画像がありません',
  'drivePicker.noAvailable': '利用可能な画像がありません',
  'drivePicker.cancel': 'キャンセル',
  'drivePicker.processing': '処理中...',
  'drivePicker.select': '選択',
  'drivePicker.loadedCount': '{count}件の画像を読み込みました',
  'drivePicker.loadError': '画像の読み込みに失敗しました',
  'drivePicker.loadErrorUnexpected': '画像の読み込み中にエラーが発生しました',
  'drivePicker.selectPlease': '画像を選択してください',
  'drivePicker.selectedSuccess': '画像を選択しました',
  'drivePicker.selectError': '画像の選択に失敗しました',

  // style preset categories
  'styleCat.popular': '人気',
  'styleCat.movements': '流行',
  'styleCat.themes': 'テーマ',
  'styleCat.techniques': 'テクニック',
  'styleCat.effects': '効果',
  'styleCat.materials': 'マテリアル',
  'styleCat.concepts': 'コンセプト',

  // style preset labels
  'styleLabel.photographic': '写真スタイル',
  'styleLabel.flat': 'フラットデザイン',
  'styleLabel.line_drawing': '線画',
  'styleLabel.line_art': 'ラインアート',
  'styleLabel.pop_art': 'ポップアート',
  'styleLabel.sketch': 'スケッチ',
  'styleLabel.anime': 'アニメ',
  'styleLabel.art_deco': 'アールデコ',
  'styleLabel.art_nouveau': 'アールヌーボー',
  'styleLabel.baroque': 'バロック',
  'styleLabel.bauhaus': 'バウハウス',
  'styleLabel.constructivism': '構成主義',
  'styleLabel.cubism': 'キュービズム',
  'styleLabel.cyberpunk': 'サイバーパンク',
  'styleLabel.fantasy': 'ファンタジー',
  'styleLabel.fauvism': 'フォービズム',
  'styleLabel.film_noir': 'フィルムノワール',
  'styleLabel.glitch_art': 'グリッチアート',
  'styleLabel.impressionism': '印象派',
  'styleLabel.industrial': 'インダストリアル',
  'styleLabel.maximalism': 'マキシマリズム',
  'styleLabel.minimalism': 'ミニマリズム',
  'styleLabel.modern_art': 'モダンアート',
  'styleLabel.modernism': 'モダニズム',
  'styleLabel.neo_expressionism': '新表現主義',
  'styleLabel.pointillism': '点描画法',
  'styleLabel.psychedelic': 'サイケデリック',
  'styleLabel.science_fiction': 'SF',
  'styleLabel.steampunk': 'スチームパンク',
  'styleLabel.surrealism': 'シュールレアリスム',
  'styleLabel.synthetism': '総合主義',
  'styleLabel.synthwave': 'シンセウェーブ',
  'styleLabel.vaporwave': 'ヴェイパーウェイヴ',
  'styleLabel.3d': '3D',
  'styleLabel.cartoon': 'カートゥーン',
  'styleLabel.cinematic': '映画風',
  'styleLabel.comic_book': 'コミックブック',
  'styleLabel.concept_art': 'コンセプトアート',
  'styleLabel.cyber_matrix': 'サイバーマトリックス',
  'styleLabel.digital_art': 'デジタルアート',
  'styleLabel.flat_design': 'フラットデザイン',
  'styleLabel.geometric': '幾何学的',
  'styleLabel.glassmorphism': 'グラスモーフィズム',
  'styleLabel.glitch_graphic': 'グリッチグラフィック',
  'styleLabel.graffiti': 'グラフィティ',
  'styleLabel.graphic_1': 'グラフィック',
  'styleLabel.hyper_realistic': '超現実的',
  'styleLabel.interior_design': 'インテリアデザイン',
  'styleLabel.line_gradient': '線形グラデーション',
  'styleLabel.low_poly': 'ローポリ',
  'styleLabel.newspaper_collage': '新聞紙のコラージュ',
  'styleLabel.optical_illusion': '錯視',
  'styleLabel.pattern_pixel': 'パターンピクセル',
  'styleLabel.pixel_art': 'ドット絵',
  'styleLabel.product_photo': '製品写真',
  'styleLabel.psychedelic_background': 'サイケデリックな背景',
  'styleLabel.psychedelic_wonderland': 'サイケデリックワンダーランド',
  'styleLabel.scandinavian': 'スカンジナビア風',
  'styleLabel.splash_images': 'スプラッシュ画像',
  'styleLabel.stamp': 'スタンプ',
  'styleLabel.trompe_loeil': 'トロンプルイユ',
  'styleLabel.vector_look': 'ベクター風',
  'styleLabel.wireframe': 'ワイヤフレーム',
  'styleLabel.acrylic_paint': 'アクリル絵の具',
  'styleLabel.bold_lines': '太い線',
  'styleLabel.chiaroscuro': 'キアロスクーロ',
  'styleLabel.color_shift_art': 'カラーシフトアート',
  'styleLabel.daguerreotype': '銀板写真',
  'styleLabel.digital_fractal': 'デジタルフラクタル',
  'styleLabel.doodle_drawing': '落書き',
  'styleLabel.double_exposure_portrait': '二重露光ポートレート',
  'styleLabel.fresco': 'フレスコ',
  'styleLabel.geometric_pen': '幾何学的なペン',
  'styleLabel.halftone': 'ハーフトーン',
  'styleLabel.ink': 'インク',
  'styleLabel.light_painting': 'ライトペインティング',
  'styleLabel.linocut': 'リノカット',
  'styleLabel.oil_paint': '油絵',
  'styleLabel.paint_splattering': 'ペンキの飛び散り',
  'styleLabel.painting': 'ペイント',
  'styleLabel.palette_knife_paint': 'パレットナイフ',
  'styleLabel.photo_manipulation': '写真加工',
  'styleLabel.scribble_texture': '手書きテクスチャ',
  'styleLabel.splattering': 'スパッタリング',
  'styleLabel.stippling_drawing': '点刻',
  'styleLabel.watercolor': '水彩画',
  'styleLabel.antique_photo': 'アンティーク写真',
  'styleLabel.bioluminescent': '生物発光',
  'styleLabel.bokeh': 'ボケ効果',
  'styleLabel.color_explosion': '色の爆発',
  'styleLabel.dark': '暗い',
  'styleLabel.faded_image': '色あせた画像',
  'styleLabel.fisheye': '魚眼',
  'styleLabel.gomori_photography': 'ゴモリ写真',
  'styleLabel.grainy_film': '粒子が粗いフィルム',
  'styleLabel.iridescent': '虹色',
  'styleLabel.isometric': 'アイソメトリック',
  'styleLabel.misty': 'もや',
  'styleLabel.neon': 'ネオン',
  'styleLabel.otherworldly_depiction': '空想的な描写',
  'styleLabel.ultraviolet': '紫外線',
  'styleLabel.underwater': '水中',
  'styleLabel.3d_patterns': '3D パターン',
  'styleLabel.charcoal': '木炭画',
  'styleLabel.claymation': 'クレイメーション',
  'styleLabel.fabric': 'ファブリック',
  'styleLabel.fur': '毛皮',
  'styleLabel.guilloche_patterns': 'ギローシェ模様',
  'styleLabel.layered_paper': '彫紙',
  'styleLabel.marble_sculpture': '大理石',
  'styleLabel.made_of_metal': '金属製',
  'styleLabel.origami': '折り紙',
  'styleLabel.paper_mache': '張り子',
  'styleLabel.polka_dot_pattern': '水玉模様',
  'styleLabel.strange_patterns': '奇妙なパターン',
  'styleLabel.wood_carving': '木彫り',
  'styleLabel.yarn': '糸',
  'styleLabel.beautiful': '美しい',
  'styleLabel.bohemian': 'ボヘミアン',
  'styleLabel.chaotic': '雑然さ',
  'styleLabel.dais': '台座',
  'styleLabel.divine': '神聖',
  'styleLabel.eclectic': '折衷主義',
  'styleLabel.futuristic': '未来派',
  'styleLabel.kitschy': 'キッチュ',
  'styleLabel.nostalgic': '懐かしさ',
  'styleLabel.simple': 'シンプル',
};

const en: TranslationDict = {
  // config-panel shared
  'configPanel.selectFile': 'Select File',
  'configPanel.selectFromDrive': 'Select from Drive',
  'configPanel.selectKeyVisual': 'Select Key Visual',

  // camera motions
  'cam.none': 'None',
  'cam.panLeft': 'Pan Left',
  'cam.panRight': 'Pan Right',
  'cam.zoomIn': 'Zoom In',
  'cam.zoomOut': 'Zoom Out',
  'cam.tiltUp': 'Tilt Up',
  'cam.tiltDown': 'Tilt Down',
  'cam.locked': 'Locked',
  'cam.handheld': 'Handheld',

  // prompt styles
  'style.none': 'None',
  'style.anime': 'Anime',
  'style.3d': '3D',
  'style.fantasy': 'Fantasy',
  'style.cinematic': 'Cinematic',
  'style.claymation': 'Claymation',
  'style.lineArt': 'Line Art',
  'style.stopMotion': 'Stop Motion',
  'style.2d': '2D',
  'style.vectorArt': 'Vector Art',
  'style.monochrome': 'Monochrome',

  // shot angles
  'angle.none': 'None',
  'angle.aerial': 'Aerial Shot',
  'angle.eyeLevel': 'Eye Level',
  'angle.high': 'High Angle',
  'angle.low': 'Low Angle',
  'angle.topDown': 'Top Down',

  // video-settings-without-size labels
  'videoSettings.cameraMotion': 'Camera Motion',
  'videoSettings.shotAngle': 'Shot Angle',
  'videoSettings.promptStyle': 'Prompt Style',
  'videoSettings.shotSize': 'Shot Size',

  // shot sizes
  'shotSize.none': 'None',
  'shotSize.closeUp': 'Close-up',
  'shotSize.extremeCloseUp': 'Extreme Close-up',
  'shotSize.medium': 'Medium Shot',
  'shotSize.long': 'Long Shot',
  'shotSize.extremeLong': 'Extreme Long Shot',

  // common
  'common.generatingImage': 'Generating image...',
  'common.weak': 'Weak',
  'common.strong': 'Strong',
  'common.resetToDefaults': 'Reset to defaults',

  // storyboard-generator
  'storyboard.title': 'Sketch to Storyboard',
  'storyboard.subtitle': 'Generate rough designs from hand-drawn sketches',
  'storyboard.addScene': 'Add Scene',
  'storyboard.detailSettings': 'Advanced Settings',
  'storyboard.styleRefImage': 'Style Reference Image',
  'storyboard.selectImage': 'Select Image',
  'storyboard.stylePreset': 'Style Presets',
  'storyboard.searchStyle': 'Search styles...',
  'storyboard.styleStrength': 'Style Strength',
  'storyboard.visualIntensity': 'Visual Intensity',
  'storyboard.structureStrength': 'Structure Strength',
  'storyboard.sceneTextPlaceholder': 'Enter text here',

  // storyboard3d
  'storyboard3d.title': '3D to Sketch',
  'storyboard3d.subtitle': 'Create storyboard using 3D models',
  'storyboard3d.viewFront': 'Front View',
  'storyboard3d.viewTop': 'Top View',
  'storyboard3d.viewSide': 'Side View',
  'storyboard3d.stockLink': 'Download 3D models from Adobe Stock',
  'storyboard3d.promptPlaceholder': 'Enter prompt for image generation...',
  'storyboard3d.generateImage': 'Generate Image',
  'storyboard3d.noImageHint': 'Set the composition with a 3D model and generate an image.',

  // key-visual-splitter
  'kvs.subtitle': 'Generate diverse variations from a single image',
  'kvs.configTitle': 'Settings',
  'kvs.uploadLabel': 'Upload Key Visual',
  'kvs.uploadPlaceholder': 'Drop or click to upload',
  'kvs.uploadHint': 'JPG, PNG, GIF, WebP (max 10MB)',
  'kvs.promptLabel': 'Describe video direction',
  'kvs.promptPlaceholder': 'Camera slowly zooms in with rays of light. Particles float in the background, creating a fantastical atmosphere.',
  'kvs.generateBtn': 'Generate Video',
  'kvs.generatingBtn': 'Generating...',
  'kvs.videoSettingsTitle': '3. Video Settings',
  'kvs.optional': '(Optional)',
  'kvs.videoSize': 'Video Size',
  'kvs.cameraMotion': 'Camera Motion',
  'kvs.splitTitle': '4. Set Split Count',
  'kvs.splitUnit': 'frames',
  'kvs.emptyTitle': 'Upload a key visual to get started',
  'kvs.emptyText': 'Select an image from the left panel and describe the video direction',
  'kvs.progressTitle': 'Generating video...',
  'kvs.resultTitle': 'Generation complete!',
  'kvs.resultSubtitle': 'Video generation and {count}-frame split complete',
  'kvs.videoSectionTitle': 'Generated Video',
  'kvs.videoNotSupported': 'Your browser does not support video playback.',
  'kvs.framesTitle': 'Split Frames ({count})',
  'kvs.splitting': 'Splitting...',
  'kvs.resplit': 'Resplit',
  'kvs.frameAlt': 'Frame',
  'kvs.stepGenerate': 'Video Generation',
  'kvs.stepSplit': 'Video Split',

  // visual-narrative-maker
  'vnm.subtitle': 'Automatically generate consistent visual stories from CSV data',
  'vnm.generatingImages': 'Generating images...',
  'vnm.generatingVideos': 'Generating videos...',
  'vnm.combiningVideos': 'Combining videos...',
  'vnm.generateSceneImages': 'Generate Scene Images',
  'vnm.generatingBtn': 'Generating...',
  'vnm.generateVideo': 'Generate Video',
  'vnm.generatingVideoBtn': 'Generating video...',
  'vnm.combineVideo': 'Combine Videos',
  'vnm.combiningBtn': 'Combining...',
  'vnm.saving': 'Saving...',
  'vnm.saveSelected': 'Save Selected Images',
  'vnm.tabScenes': 'Scene Preview',
  'vnm.tabCombined': 'Combined Video',
  'vnm.sceneN': 'Scene {n}',
  'vnm.detailSettings': 'Advanced Settings',
  'vnm.regenerateImage': 'Regenerate Image',
  'vnm.regenerateVideo': 'Regenerate Video',
  'vnm.deleteScene': 'Delete Scene',
  'vnm.delete': 'Delete',
  'vnm.prompt': 'Prompt',
  'vnm.promptPlaceholder': 'Enter prompt',
  'vnm.negativePrompt': 'Negative Prompt',
  'vnm.negativePromptPlaceholder': 'Enter negative prompt (optional)',
  'vnm.cameraMotion': 'Camera Motion',
  'vnm.generatedImage': 'Generated Image',
  'vnm.sceneImageAlt': 'Scene {n} Image',
  'vnm.placeholder': 'Placeholder',
  'vnm.variationAlt': 'Variation {n}',
  'vnm.generatedVideo': 'Generated Video',
  'vnm.addScene': '+ Add Scene',
  'vnm.emptyHint': 'Enter scene information to generate a video',
  'vnm.emptySubHint': 'Entering detailed prompts for each scene will produce higher quality results',
  'vnm.editVideo': 'Edit Video',
  // csv uploader
  'vnm.csvUpload': 'CSV Upload',
  'vnm.selectCsv': 'Select CSV',
  // style config
  'vnm.styleRefMode': 'Style Reference Mode',
  'vnm.refImage': 'Reference Image',
  'vnm.customModel': 'Custom Model (Style)',
  'vnm.dropStyleImage': 'Drop style reference image',
  'vnm.styleImageHint': 'The base image for the style applied to the generated scenes',
  'vnm.selectFile': 'Select File',
  'vnm.selectFromDrive': 'Select from Drive',
  'vnm.uploadingImage': 'Loading image...',
  'vnm.styleRefImageAlt': 'Style Reference Image',
  'vnm.styleStrengthLabel': 'Style Strength: ',
  'vnm.loadingCustomModels': 'Loading custom models...',
  'vnm.selectCustomModel': 'Select Custom Model',
  'vnm.noCustomModels': 'No custom models available',
  'vnm.selectedModelInfo': 'Selected Model Info:',
  'vnm.keyword': 'Keyword: ',
  'vnm.modelVersion': 'Model Version: ',
  'vnm.samplePrompt': 'Sample Prompt: ',
  'vnm.visualIntensityLabel': 'Visual Intensity: ',
  'vnm.videoSettings': 'Video Settings',
  'vnm.videoSizeAll': 'Video Size (all scenes)',
  'vnm.defaultCameraMotion': 'Default Camera Motion',
  'vnm.selectStyleRef': 'Select Style Reference Image',
  // scene preview
  'vnm.promptLabel': 'Prompt:',
  'vnm.negativePromptLabel': 'Negative Prompt:',
  'vnm.sceneIndividualSettings': 'Scene Video Settings',
  'vnm.videoSettingsTitle': 'Video Settings',

  // custom-model-generator
  'cmig.title': 'Custom Model Image Generator',
  'cmig.subtitle': 'Image generation using Firefly custom models',
  'cmig.customModel': 'Custom Model',
  'cmig.loadingModels': 'Loading custom models...',
  'cmig.selectModel': 'Select model',
  'cmig.selectModelPlaceholder': 'Select a custom model',
  'cmig.noModels': 'No custom models available',
  'cmig.numImages': 'Number of images',
  'cmig.numImagesOption1': '1 image',
  'cmig.numImagesOption2': '2 images',
  'cmig.numImagesOption4': '4 images',
  'cmig.ratio': 'Ratio',
  'cmig.structureImage': 'Structure image',
  'cmig.dragDrop': 'Drag & drop',
  'cmig.formatsHint': 'JPG / PNG (Min 512x512 px, Max 15MB)',
  'cmig.structureImagePreviewAlt': 'Structure image preview',
  'cmig.removeStructureImage': 'Remove structure image',
  'cmig.stuctureImageCm5warning': 'When using a structure image, the Ratio field cannot be used',
  'cmig.uploading': 'Uploading...',
  'cmig.generatingImage': 'Generating image...',
  'cmig.generationResults': 'Generation results :',
  'cmig.downloadImage': 'Download image',
  'cmig.generatedImageAlt': 'Generated image {index}',
  'cmig.placeholderTitle': 'Two images will be generated sequentially from the prompt.',
  'cmig.placeholderTip1': 'Please be sure to specify the aspect ratio.',
  'cmig.placeholderTip2': 'By describing the desired content in greater detail.',
  'cmig.promptLabel': 'Prompt',
  'cmig.promptPlaceholder': 'Describe the image you want to generate...',
  'cmig.termsTitle': 'PVS Terms & Conditions',
  'cmig.permittedUseLabel': 'Permitted Use',
  'cmig.permittedUseBody1': 'The PVS system may be used only to promote Panasonic products and services. Use for any other purpose is strictly prohibited.',
  'cmig.permittedUseBody2': 'These Terms & Conditions apply both to content generated using PVS and to existing content modified using PVS.',
  'cmig.permittedUseBody3': 'In addition to complying with these Terms & Conditions, all users must comply with all applicable rules, requirements and restrictions set out in Panasonic\'s Global Guidelines for Generative AI Image, Video and Voice Content, as amended or updated from time to time.',
  'cmig.externalSuppliersTitle': 'External suppliers and individual creators',
  'cmig.externalSuppliersBody': 'External suppliers, individual creators and other third parties may use PVS solely for projects formally commissioned by Panasonic. Any use outside the scope of the commissioned projects is strictly prohibited.',
  'cmig.panasonicEmployeesTitle': 'Panasonic Group employees worldwide',
  'cmig.panasonicEmployeesBody': 'Panasonic Group employees worldwide must not allow another company or third party to use PVS for any purpose other than creating promotional materials for Panasonic products and services.',
  'cmig.doWord': 'DO',
  'cmig.doNotWord': 'DO NOT',
  'cmig.aiModelSelectionTitle': 'AI Model Selection',
  'cmig.aiModelSelectionDo1': 'use Adobe Firefly with the Panasonic Custom Model.',
  'cmig.aiModelSelectionDoNot1': 'use any Adobe Firefly Partner Models. They do not have the same commercial-use rights, IP indemnification or training-data transparency.',
  'cmig.beforeGenTitle': 'Before Content Generation',
  'cmig.beforeGenDoNot1': 'use PVS to create or modify content that shows or implies product benefits in a misleading, exaggerated, or false way, or otherwise misrepresents a product or service, its features, performance, results, or any other material claim.',
  'cmig.beforeGenDoNot2': 'enter confidential information, personal information, confidential information provided to Panasonic by a third party, or product information that is not yet public.',
  'cmig.beforeGenDoNot3': 'enter information that could be defamatory or infringe another person\'s privacy.',
  'cmig.beforeGenDoNot4': 'use prompts or reference images containing any named or uniquely identifiable subject, such as a person, fictional character, title of a creative work, landmark, building, or brand.',
  'cmig.beforeGenDoNot5': 'use prompts or reference images containing any content that could result in copyright infringement, including visual assets created by others.',
  'cmig.beforeGenDoNot6': 'ask PVS to copy a named artist, a well-known artistic style, or an existing work.',
  'cmig.beforeGenDoNot7': 'use PVS to change the race or gender of a person in any content.',
  'cmig.beforeGenDoNot8': 'use Sketch to Storyboard, 3D to Sketch, Visual Narrative Maker or Key Frame Generator in Panasonic Visual Studio unless prior approval has been obtained from the Global Marketing Division Brand Strategy Department (to request approval, email: pvs@ml.jp.panasonic.com).',
  'cmig.beforeGenDo1': 'consider whether the planned content could create reputational or social risk, including public criticism or backlash.',
  'cmig.beforeGenDo2': 'ensure that all content generations using PVS comply with the applicable local laws and regulations.',
  'cmig.beforeGenDo3': 'retain a record of the prompts used for content generation to help address any issues that may arise.',
  'cmig.beforeGenDo4': 'take extra care when generating illustrations. Their artistic styles are more easily recognized than photorealistic images, increasing the risk of resembling existing copyrighted works.',
  'cmig.afterGenTitle': 'After Content Generation',
  'cmig.afterGenDoNot1': 'use any content generated using PVS that infringes, or could infringe, another party\'s copyright, trademark, or other intellectual-property rights, including content that looks too similar to an existing work, product, object, character, logo, or design.',
  'cmig.afterGenDoNot2': 'use any content generated using PVS that imitates or could reasonably be mistaken for an identifiable person\'s likeness or appearance without the relevant rights or permission.',
  'cmig.afterGenDoNot3': 'use any content generated using PVS that uses, imitates, or closely resembles the name, crest, badge, logo, mascot, kit, uniform, or other distinctive identity of a sports team, club, league, or competition, including a distinctive combination of colors and design elements, without the relevant rights or permission.',
  'cmig.afterGenDoNot4': 'use any content generated using PVS if a similarity check finds that it is too similar to an existing work. Create a new version or edit it so that it is sufficiently distinct from the existing work.',
  'cmig.afterGenDoNot5': 'use any product image generated using PVS as an official image of a Panasonic product. PVS may change the product shape, detail or finish.',
  'cmig.afterGenDo1': 'edit and post-produce contents generated using PVS before use. Correct unnatural elements, visual inconsistencies, layout and other quality problems.',
  'cmig.afterGenDo2': 'check whether the content generated using PVS looks too similar to an existing work, product or object. Use a reverse-image search or an AI service approved for this purpose, but only when the content does not contain confidential material.',
  'cmig.afterGenDo3': 'check that the content generated using PVS is accurate, consistent, follows Panasonic brand guidelines, does not contain discrimination, does not use third-party content unless a contract or written permission expressly allows Generative-AI editing, and is suitable for its intended use.',
  'cmig.afterGenDo4': 'consider whether copyright protection is needed for the intended content. Where it is needed, ensure sufficient human creative input; prompting alone may not be sufficient. Consult Legal in case of doubt.',
  'cmig.afterGenDo5': 'ensure that content generated using PVS comply with the applicable local laws and regulations.',
  'cmig.afterGenDo6': 'label or watermark the content generated using PVS when local law or regulation requires it.',
  'cmig.afterGenDo7': 'follow any applicable Panasonic regional labelling or disclosure requirements, including requirements for AI-modified content.',
  'cmig.afterGenDo9': 'composite an approved photograph of the real Panasonic product into the final creative during post-production when a Panasonic product appears in the content generated using PVS.',
  'cmig.afterGenDo10': 'save the content generated using PVS and the prompts before generating the next content, as they are automatically deleted after each session.',
  'cmig.afterGenDo11': 'ensure that, excluding yourself, at least two managers (including one communication manager) review and approve the content generated using PVS before it is used externally',
  'cmig.bestPracticeTitle': 'Best Practice',
  'cmig.bestPracticeDo1': 'use reference images with the same aspect ratio as the desired output content where possible to help maintain output quality.',
  'cmig.bestPracticeDo2': 'avoid generating content containing text-based elements, as AI-generated text cannot be guaranteed to be accurate.',
  'cmig.bestPracticeDo3': 'pay particular attention to content containing people, as they are particularly prone to unnatural artefacts, such as missing fingers or other anatomical inconsistencies.',
  'cmig.bestPracticeDo4': 'take extra care when generating content including plants or other natural subjects, as AI may generate inaccurate or non-existent species.',
  'cmig.confirmBefore': 'Confirm Before Generating',
  'cmig.confidentialInfoLabel': 'Confidential Information:',
  'cmig.confidentialInfoBody': 'DO NOT use unreleased information in reference images.',
  'cmig.copyrightLabel': 'Copyright:',
  'cmig.copyrightBody': 'DO NOT use copyrighted content (in both prompt and reference images).',
  'cmig.matchAspectRatioLabel': 'Match Reference Aspect Ratio:',
  'cmig.matchAspectRatioBody': 'Aligning the aspect ratio of the reference image with that of the image you want to generate will produce better results.',
  'cmig.confirmAfter': 'Confirm After Generating',
  'cmig.saveImmediatelyLabel': 'Save Immediately:',
  'cmig.saveImmediatelyBody': 'Generated images are AUTO-DELETED. ALWAYS SAVE them before generating a new image.',
  'cmig.checkSimilarityLabel': 'Check Similarity:',
  'cmig.checkSimilarityBody': 'Look for resemblance to existing products/objects.',
  'cmig.ethicalCheckLabel': 'Ethical Check:',
  'cmig.ethicalCheckBody': 'Verify there are no stereotypes or inappropriate content in the generated images.',
  'cmig.legalComplianceLabel': 'Legal Compliance:',
  'cmig.legalComplianceBody': 'Follow local legal requirements. Add watermarks if required by local laws.',
  'cmig.qualityCheckLabel': 'Quality Check:',
  'cmig.qualityCheckBody': 'Have 3+ people review for unnatural elements (e.g., wrong number of fingers, odd details). Retouch as needed.',
  'cmig.brandSafetyLabel': 'Brand Safety:',
  'cmig.brandSafetyBody': 'Be careful with images showing 3+ people—there is a higher risk of errors. (e.g., unnatural anatomy, distorted features, or inconsistent human rendering.)',
  'cmig.productImagesLabel': 'Product Images:',
  'cmig.productImagesBody': 'AI-generated images are for illustrative purposes only. Always retouch them and blend in actual product images for final use. (Panasonic products only)',
  'cmig.generate': 'Generate',
  'cmig.generating': 'Generating...',
  'cmig.promptGuideTitle': 'Prompt Guide',
  'cmig.promptGuideText': 'To generate high-quality images, describe the subject clearly with specific details about lighting, composition, and style. Include visual elements such as color palette, texture, and atmosphere. Specify the angle or perspective if needed — for example, "wide-angle shot" or "close-up". Avoid vague terms and use descriptive adjectives to guide the model effectively toward your intended visual output.',
  'cmig.toast.fileTooLarge': 'File size too large (max 15MB)',
  'cmig.toast.structureUploadSuccess': 'Structure image uploaded successfully',
  'cmig.toast.structureUploadFailed': 'Failed to upload structure image',
  'cmig.toast.jobStartFailed': 'Failed to start job',
  'cmig.toast.imageGenerated': 'Image generated successfully',
  'cmig.toast.emptyResult': 'Image generation completed, but the result was empty',
  'cmig.toast.noResultFound': 'Image generation completed, but no result was found',
  'cmig.toast.generationFailed': 'Image generation failed: {detail}',
  'cmig.toast.statusFetchFailed': 'Failed to fetch image generation status',
  'cmig.toast.requestFailed': 'Failed to start image generation',
  'cmig.toast.downloadFailed': 'Failed to download image',

  // toast messages — storyboard / storyboard3d
  'toast.structureUploadError': 'Structure image upload failed',
  'toast.jobStartFailed': 'Failed to start image generation job',
  'toast.imageResultEmpty': 'Image generation result is empty',
  'toast.imageGenFailed': 'Image generation failed: {detail}',
  'toast.jobMonitorError': 'Error during job monitoring: {detail}',
  'toast.unknownError': 'Unknown error',
  'toast.unknownErrorOccurred': 'An unknown error occurred',
  'toast.imageUploadFailed': 'Image upload failed',
  'toast.imageGenRequestFailed': 'Image generation request failed',
  'toast.imageGenRequestFailedDetail': 'Image generation request failed: {detail}',
  'toast.imageGenComplete': 'Image generation complete',
  'toast.imageLoadFailed': 'Failed to load image: {url}',
  'toast.unsupportedModel': 'Supported formats: .obj, .glb, .gltf, .fbx',
  'toast.objLoaded': 'OBJ model loaded.',
  'toast.objLoadFailed': 'Failed to load OBJ file.',
  'toast.gltfLoaded': 'GLTF/GLB model loaded.',
  'toast.gltfLoadFailed': 'Failed to load GLTF/GLB file.',
  'toast.fbxLoaded': 'FBX model loaded.',
  'toast.fbxLoadFailed': 'Failed to load FBX file. The file may be corrupted.',
  // toast messages — storyboard-settings
  'toast.fileTooLarge': 'File size too large (max 10MB)',
  'toast.unsupportedFormat': 'Unsupported file format',
  'toast.styleImageUploaded': 'Style reference image uploaded',
  'toast.styleImageUploadFailed': 'Failed to upload style reference image',
  'toast.settingsReset': 'Settings reset to defaults',
  // toast messages — config-panel
  'toast.imageSelected': 'Image selected: {prompt}...',
  'toast.fileSizeExceeded': 'File size exceeds {maxSize}MB',
  // toast messages — narrative-style-config
  'toast.styleRefSelected': 'Style reference image selected: {prompt}...',
  // toast messages — narrative-error-handler
  'toast.sceneImageGenError': 'Scene {n} image generation error: {detail}',
  'toast.imageGenError': 'Image generation error: {detail}',
  'toast.sceneVideoGenError': 'Scene {n} video generation error: {detail}',
  'toast.videoGenError': 'Video generation error: {detail}',
  'toast.fileUploadError': 'File upload error: {detail}',
  'toast.videoCombineError': 'Video combine error: {detail}',
  'toast.validationErrorPrefix': 'Validation error: {detail}',
  // kvs — visual-split.service toasts
  'kvs.resplitFailed': 'Resplit failed',
  'kvs.apiChecking': 'Checking Firefly video generation API...',
  'kvs.videoJobStarted': 'Video generation job started',
  'kvs.videoJobStartFailed': 'Failed to start video generation job',
  'kvs.generatingVideo': 'Generating video... ({status})',
  'kvs.videoGenComplete': 'Video generation complete',
  'kvs.videoUrlFailed': 'Failed to get video URL',
  'kvs.videoGenFailed': 'Video generation failed',
  'kvs.videoGenError': 'Video generation error',
  'kvs.videoSplitError': 'Video split error',
  'kvs.imageUploadFailed': 'Image upload failed',
  'kvs.networkError': 'A network error occurred',
  'kvs.requestError': 'A request error occurred',
  'kvs.serverError': 'A server error occurred',
  'kvs.generalError': 'An error occurred',
  'kvs.resplitSuccess': 'Resplit video into {count} frames',

  // vnm — workflow/generation service toasts
  'vnm.err.noScenes': 'No scenes',
  'vnm.err.allScenesNotGenerated': 'Not all scene images have been generated',
  'vnm.err.noGeneratedImages': 'No generated images found',
  'vnm.err.minVideosForCombine': 'At least 2 videos are required to combine',
  'vnm.err.noCombinedVideo': 'No video to edit',
  'vnm.err.noSceneImageSelected': 'No scene image selected',
  'vnm.err.scenePromptRequired': 'Please enter a prompt for scene(s) {scenes}',
  'vnm.err.videoCombinateFailed': 'Failed to combine videos',
  'vnm.err.imageJobStartFailed': 'Failed to start image generation job',
  'vnm.err.imageUploadFailed': 'Image upload failed',
  'vnm.err.csvEmpty': 'CSV file is empty',
  'vnm.err.csvNoPromptHeader': 'CSV requires a "prompt" header',
  'vnm.err.csvInvalidFormat': 'Invalid CSV file format',
  'vnm.err.csvReadError': 'Error reading file',
  'vnm.err.fileTypeInvalid': 'Unsupported file type',
  'vnm.err.fileSizeTooLarge': 'File size too large (max 10MB)',
  'vnm.err.fileReadFailed': 'Failed to read file',
  'vnm.success.scenesLoaded': 'Loaded {count} scenes',
  'vnm.success.sceneImageGenComplete': 'Scene image generation complete',
  'vnm.success.sceneVideoGenComplete': 'Scene video generation complete',
  'vnm.success.allImagesGenerated': 'All images generated successfully',
  'vnm.success.videoGenComplete': 'Video generation complete',
  'vnm.success.videoCombineComplete': 'Video combination complete',
  'vnm.success.videoEditComplete': 'Video editing complete',
  'vnm.info.generatingVideoFromScenes': 'Generating video from {count} scenes',
  'vnm.info.scenesGenerated': '{count} scene videos generated',
  'vnm.info.combiningVideos': 'Combining scene videos...',

  // google-drive-image-selector
  'drivePicker.close': 'Close',
  'drivePicker.searchPlaceholder': 'Search by prompt...',
  'drivePicker.loading': 'Loading images...',
  'drivePicker.noImages': 'No images found',
  'drivePicker.noSearchResults': 'No images match your search',
  'drivePicker.noAvailable': 'No images available',
  'drivePicker.cancel': 'Cancel',
  'drivePicker.processing': 'Processing...',
  'drivePicker.select': 'Select',
  'drivePicker.loadedCount': 'Loaded {count} images',
  'drivePicker.loadError': 'Failed to load images',
  'drivePicker.loadErrorUnexpected': 'An error occurred while loading images',
  'drivePicker.selectPlease': 'Please select an image',
  'drivePicker.selectedSuccess': 'Image selected',
  'drivePicker.selectError': 'Failed to select image',

  // style preset categories
  'styleCat.popular': 'Popular',
  'styleCat.movements': 'Movements',
  'styleCat.themes': 'Themes',
  'styleCat.techniques': 'Techniques',
  'styleCat.effects': 'Effects',
  'styleCat.materials': 'Materials',
  'styleCat.concepts': 'Concepts',

  // style preset labels
  'styleLabel.photographic': 'Photographic',
  'styleLabel.flat': 'Flat Design',
  'styleLabel.line_drawing': 'Line Drawing',
  'styleLabel.line_art': 'Line Art',
  'styleLabel.pop_art': 'Pop Art',
  'styleLabel.sketch': 'Sketch',
  'styleLabel.anime': 'Anime',
  'styleLabel.art_deco': 'Art Deco',
  'styleLabel.art_nouveau': 'Art Nouveau',
  'styleLabel.baroque': 'Baroque',
  'styleLabel.bauhaus': 'Bauhaus',
  'styleLabel.constructivism': 'Constructivism',
  'styleLabel.cubism': 'Cubism',
  'styleLabel.cyberpunk': 'Cyberpunk',
  'styleLabel.fantasy': 'Fantasy',
  'styleLabel.fauvism': 'Fauvism',
  'styleLabel.film_noir': 'Film Noir',
  'styleLabel.glitch_art': 'Glitch Art',
  'styleLabel.impressionism': 'Impressionism',
  'styleLabel.industrial': 'Industrial',
  'styleLabel.maximalism': 'Maximalism',
  'styleLabel.minimalism': 'Minimalism',
  'styleLabel.modern_art': 'Modern Art',
  'styleLabel.modernism': 'Modernism',
  'styleLabel.neo_expressionism': 'Neo-Expressionism',
  'styleLabel.pointillism': 'Pointillism',
  'styleLabel.psychedelic': 'Psychedelic',
  'styleLabel.science_fiction': 'Science Fiction',
  'styleLabel.steampunk': 'Steampunk',
  'styleLabel.surrealism': 'Surrealism',
  'styleLabel.synthetism': 'Synthetism',
  'styleLabel.synthwave': 'Synthwave',
  'styleLabel.vaporwave': 'Vaporwave',
  'styleLabel.3d': '3D',
  'styleLabel.cartoon': 'Cartoon',
  'styleLabel.cinematic': 'Cinematic',
  'styleLabel.comic_book': 'Comic Book',
  'styleLabel.concept_art': 'Concept Art',
  'styleLabel.cyber_matrix': 'Cyber Matrix',
  'styleLabel.digital_art': 'Digital Art',
  'styleLabel.flat_design': 'Flat Design',
  'styleLabel.geometric': 'Geometric',
  'styleLabel.glassmorphism': 'Glassmorphism',
  'styleLabel.glitch_graphic': 'Glitch Graphic',
  'styleLabel.graffiti': 'Graffiti',
  'styleLabel.graphic_1': 'Graphic',
  'styleLabel.hyper_realistic': 'Hyper Realistic',
  'styleLabel.interior_design': 'Interior Design',
  'styleLabel.line_gradient': 'Line Gradient',
  'styleLabel.low_poly': 'Low Poly',
  'styleLabel.newspaper_collage': 'Newspaper Collage',
  'styleLabel.optical_illusion': 'Optical Illusion',
  'styleLabel.pattern_pixel': 'Pattern Pixel',
  'styleLabel.pixel_art': 'Pixel Art',
  'styleLabel.product_photo': 'Product Photo',
  'styleLabel.psychedelic_background': 'Psychedelic Background',
  'styleLabel.psychedelic_wonderland': 'Psychedelic Wonderland',
  'styleLabel.scandinavian': 'Scandinavian',
  'styleLabel.splash_images': 'Splash Images',
  'styleLabel.stamp': 'Stamp',
  'styleLabel.trompe_loeil': "Trompe-l'oeil",
  'styleLabel.vector_look': 'Vector Look',
  'styleLabel.wireframe': 'Wireframe',
  'styleLabel.acrylic_paint': 'Acrylic Paint',
  'styleLabel.bold_lines': 'Bold Lines',
  'styleLabel.chiaroscuro': 'Chiaroscuro',
  'styleLabel.color_shift_art': 'Color Shift Art',
  'styleLabel.daguerreotype': 'Daguerreotype',
  'styleLabel.digital_fractal': 'Digital Fractal',
  'styleLabel.doodle_drawing': 'Doodle Drawing',
  'styleLabel.double_exposure_portrait': 'Double Exposure Portrait',
  'styleLabel.fresco': 'Fresco',
  'styleLabel.geometric_pen': 'Geometric Pen',
  'styleLabel.halftone': 'Halftone',
  'styleLabel.ink': 'Ink',
  'styleLabel.light_painting': 'Light Painting',
  'styleLabel.linocut': 'Linocut',
  'styleLabel.oil_paint': 'Oil Paint',
  'styleLabel.paint_splattering': 'Paint Splattering',
  'styleLabel.painting': 'Painting',
  'styleLabel.palette_knife_paint': 'Palette Knife',
  'styleLabel.photo_manipulation': 'Photo Manipulation',
  'styleLabel.scribble_texture': 'Scribble Texture',
  'styleLabel.splattering': 'Splattering',
  'styleLabel.stippling_drawing': 'Stippling',
  'styleLabel.watercolor': 'Watercolor',
  'styleLabel.antique_photo': 'Antique Photo',
  'styleLabel.bioluminescent': 'Bioluminescent',
  'styleLabel.bokeh': 'Bokeh',
  'styleLabel.color_explosion': 'Color Explosion',
  'styleLabel.dark': 'Dark',
  'styleLabel.faded_image': 'Faded Image',
  'styleLabel.fisheye': 'Fisheye',
  'styleLabel.gomori_photography': 'Gomori Photography',
  'styleLabel.grainy_film': 'Grainy Film',
  'styleLabel.iridescent': 'Iridescent',
  'styleLabel.isometric': 'Isometric',
  'styleLabel.misty': 'Misty',
  'styleLabel.neon': 'Neon',
  'styleLabel.otherworldly_depiction': 'Otherworldly Depiction',
  'styleLabel.ultraviolet': 'Ultraviolet',
  'styleLabel.underwater': 'Underwater',
  'styleLabel.3d_patterns': '3D Patterns',
  'styleLabel.charcoal': 'Charcoal',
  'styleLabel.claymation': 'Claymation',
  'styleLabel.fabric': 'Fabric',
  'styleLabel.fur': 'Fur',
  'styleLabel.guilloche_patterns': 'Guilloche Patterns',
  'styleLabel.layered_paper': 'Layered Paper',
  'styleLabel.marble_sculpture': 'Marble Sculpture',
  'styleLabel.made_of_metal': 'Made of Metal',
  'styleLabel.origami': 'Origami',
  'styleLabel.paper_mache': 'Paper Mache',
  'styleLabel.polka_dot_pattern': 'Polka Dot Pattern',
  'styleLabel.strange_patterns': 'Strange Patterns',
  'styleLabel.wood_carving': 'Wood Carving',
  'styleLabel.yarn': 'Yarn',
  'styleLabel.beautiful': 'Beautiful',
  'styleLabel.bohemian': 'Bohemian',
  'styleLabel.chaotic': 'Chaotic',
  'styleLabel.dais': 'Dais',
  'styleLabel.divine': 'Divine',
  'styleLabel.eclectic': 'Eclectic',
  'styleLabel.futuristic': 'Futuristic',
  'styleLabel.kitschy': 'Kitschy',
  'styleLabel.nostalgic': 'Nostalgic',
  'styleLabel.simple': 'Simple',
};

export const translations: Record<'ja' | 'en', TranslationDict> = { ja, en };
